export const getShareUploadFields = ({ passwordless, customPassword }) => {
  if (passwordless) {
    return { passwordless: 'true' };
  }

  if (customPassword) {
    return { customPassword };
  }

  return {};
};

export const shouldAutoAccess = ({ passwordRequired, requireEmail }) => (
  passwordRequired === false && !requireEmail
);

export const getAccessPayload = ({ passwordRequired, values = {} }) => {
  const payload = {};

  if (values.email) {
    payload.email = values.email;
  }

  if (passwordRequired && values.password) {
    payload.password = values.password;
  }

  return payload;
};

export const createAutoAccessGate = () => {
  let startedShareId = null;

  return {
    shouldStart({ shareId, passwordRequired, requireEmail }) {
      if (
        startedShareId === shareId ||
        !shouldAutoAccess({ passwordRequired, requireEmail })
      ) {
        return false;
      }

      startedShareId = shareId;
      return true;
    },
  };
};
